<template>
    <section class="snsshare-wrap">
        <div class="role-bg-wrap">
            <img src="../../assets/images/home/sns/bg.png" alt="">
        </div>

        <transition name="check-cover">
            <div class="cover" key="cover" v-if="!share">
                <p class="title">
                    <span>명일방주 사전예약 공유 이벤트</span>
                    <i class="iconfont iconfenxiang share"></i>
                </p>
                <!-- <p class="text">
                    사전예약 소식을 <mark href="">SNS에 공유</mark>하면 <mark href="">푸짐한 상품 획득</mark>의 기회가 주어집니다!
                </p> -->
                <div class="share-wrap">
                    <a href="javascript:void(0);" @click="checkSnsShare('fb')" class="share-btn share-btn--fb"><img src="../../assets/images/home/sns/share_fb.png" alt=""></a>
                    <a href="javascript:void(0);" @click="checkSnsShare('tw')" class="share-btn share-btn--tw"><img src="../../assets/images/home/sns/share_tw.png" alt=""></a>
                    <a href="javascript:void(0);" @click="checkSnsShare('kakao')" class="share-btn share-btn--kakao"><img src="../../assets/images/home/sns/share_kakao.png" alt=""></a>
                </div>
                <p class="adorn"></p>
                <div class="caption">
                    <p class="caption-text">이벤트 상품</p>
                </div>
                <div class="gift">
                    <img src="../../assets/images/home/sns/gift.png" alt="">
                </div>
                <p class="adorn"></p>
                <div class="caption">
                    <p class="caption-text">이벤트 유의사항</p>
                </div>
                <div class="sns-tip">
                    <p>- 본 이벤트는 공식 오픈 전까지만 진행</p>
                    <p>- 당첨자는 정식 오픈 후 명일방주 공식 SNS 채널을 통해 별도 공지</p>
                    <p>- <mark class="mark-yellow">본 페이지</mark>의 이벤트 참여자 중 무작위 추첨</p>
                    <p>- <mark class="mark-yellow">페이스북 / 트위터 / 카카오스토리</mark>에 공유 시, 아래 해쉬태그 반드시 포함할 것</p>
                    <p class="sns-tip--indent"><mark class="mark-blue">#명일방주 #명일방주사전예약개시</mark></p>
                    <p>- 참여 횟수 제한 없음. 공유 횟수가 많을 수록 당첨 확률 상승</p>
                    <p><mark class="mark-yellow">※명일방주 공식 홈페이지가 아닌 다른 루트로 공유 시 이벤트 집계 대상에 포함되지 않습니다</mark></p>
                </div>
            </div>
            <div class="sns-check-cover" key="sns-check-cover" v-else>
                <div class="sns-check-box">
                    <i class="iconfont iconguanbi sns-check-btn--close" @click="closeCheckSns"></i>
                    <p class="sns-check-title">이미 사전예약을 완료하셨다면,</p>
                    <p class="sns-check-title">등록한 번호를 입력해주시기 바랍니다.</p>
                    <div class="phone-box">
                        <div class="phone-pre-num">010 -</div>
                        <div class="phone-content">
                            <input class="phone-content-input" v-model.number.trim="phoneNum" type="tel" placeholder="- 를 제외한 휴대폰 번호를 입력해주세요.">
                        </div>
                    </div>
                    <div class="sns-check-btn" @click="checktelephone">
                        <span>사전예약 확인</span>
                    </div>
                    <p class="sns-check-p"></p>
                    <p class="sns-check-tip">본 이벤트는 사전예약 신청 완료 후 참여 가능합니다.</p>
                    <img src="../../assets/images/home/sns/toprereg.png" class="toprereg-btn" alt="" @click="toPrereg">
                </div>
            </div>
        </transition>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "SnsShare",

    components: {

    },
    data: () => ({
        share: false,
        phoneNum: "",
        shareChannle: "",
    }),
    created() {
    },
    mounted() {

    },
    watch: {

    },
    computed: {
        ...mapState({
            FULLPAGE: state => state.Home.FULLPAGE
        }),
        checkoutPhoneNum() {
            // 检查电话号码格式（去除010，8位）
            return /^\d{8}$/.test(this.phoneNum)
        },
        completePhoneNum() {
            // 完整的电话号码（前面加上010）
            return `010${this.phoneNum}`
        }
    },
    methods: {
        checkSnsShare(channel) {
            this.shareChannle = channel
            const tel = sessionStorage.getItem("tel")

            if(!tel) {
                this.share = true
            } else {
                this.$utils.snsShare(channel)
                this.snsShare(this.shareChannle, tel)
            }
        },
        closeCheckSns() {
            this.share = false;
        },
        checktelephone() {
            if(!this.checkoutPhoneNum) {
                alert("정확한 휴대폰 번호를 입력하여 주십시오.")
                return false
            }
            this.axios.post("/prereg/checkqualify", {
                "telephone": this.completePhoneNum
            }).then(v => {
                console.log(v)
                if(v.retcode === 0) {
                    // 有资格
                    // 保存号码到 sessionStorage
                    sessionStorage.setItem("tel", this.completePhoneNum)
                    this.snsShare(this.shareChannle, this.completePhoneNum)
                    this.share = false
                } else {
                    // 没有资格
                    alert("사전예약 완료 후 참여 가능합니다.")
                }
            }).catch(e => {
                console.log(e)
                alert("unexpected error!")
            })
        },
        snsShare(channel, telephone) {
            this.axios.post("/prereg/snsshare", {
                "telephone": telephone,
                "plat": channel
            }).then(v => {
                console.log(v)
            }).catch(e => {
                console.log(e)
            })
            this.$utils.snsShare(channel)
        },
        toPrereg() {
            this.FULLPAGE.goTo(2)
        }
    },
};
</script>

<style lang="scss" scoped>
.snsshare-wrap {
    background: linear-gradient(135deg, #3f3f40, #3f3f40 35%, #141516 35%);

    .role-bg-wrap {
        display: inline-block;
        height: 100%;
        width: auto;
        background: linear-gradient(to right, #080808, #080808 65%, #080808d3 85%, #08080805);

        img {
            height: 100%;
        }
    }
    
    .cover {
        position: absolute;
        top: 50%;
        right: pxTorem(250px);
        transform: translateY(-50%);
        width: pxTorem(790px);
        z-index: 99;
        
        .title {
            display: flex;
            align-items: center;
            margin-bottom: pxTorem(25px);
            
            span {
                color: #fff;
                font-size: pxTorem(46px);
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: bold;
                margin-right: pxTorem(24px);
            }
            .share {
                color: #feef00;
                font-size: pxTorem(40px);
            }
        }
        .text {
            font-size: pxTorem(16px);
            color: #fff;
            margin-bottom: pxTorem(40px);
            font-family: 'Noto Sans KR', sans-serif;
            letter-spacing: 2px;
            
            mark {
                color: #feef00;
                position: relative;
                background: transparent;
                &::after {
                    content: "";
                    display: block; 
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, #ffd600, #ff9b00);
                    position: absolute;
                    bottom: -5px;
                    left: 0;
                }
            }
        }
        .share-wrap {
            display: flex;
            justify-content: space-between;

            .share-btn {
                display: block;
                width: pxTorem(245px);

                img {
                    display: block;
                    width: 100%;
                }
            }
        }
        .adorn {
            width: 100%;
            height: 2px;
            background: linear-gradient(to right, #957b0a31, #957c0a 25%, #957b0a52 50%, #957c0a 75%, #957b0a31);
            margin: pxTorem(30px) 0 pxTorem(22px);
        }
        .caption {
            width: 100%;
            height: pxTorem(38px);
            display: flex;

            &::before {
                content: "";
                display: block;
                width: pxTorem(8px);
                height: 100%;
                background: #fff000;
                margin-right: pxTorem(4px);
            }

            .caption-text {
                height: 100%;
                background: linear-gradient(to right, #3b2707 10%, #373314 20%,  #191a163a 30%, #191a160e);
                flex: 1;
                color: #fff;
                font-size: pxTorem(16px);
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: bold;
                line-height: pxTorem(38px);
                text-indent: 1em;
            }
        }
        .gift {
            width: 100%;
            img {
                width: 100%;
            }
        }
        .sns-tip {
            margin-top: pxTorem(20px);
            color: #fff;
            font-size: pxTorem(16px);
            font-family: 'Noto Sans KR', sans-serif;
            letter-spacing: 2px;

            .sns-tip--mark {
                color: #fae001;
            }
            
            .sns-tip--indent {
                text-indent: 5em;
            }
            .mark-yellow {
                color: #fae001;
                background: transparent;
            }
            .mark-blue {
                color: #00c6ff;
                background: transparent;
            }
            .sns-tip--indent {
                text-indent: 0.8em;
            }
        }
    }
    .sns-check-cover {
        position: absolute;
        top: 50%;
        right: pxTorem(250px);
        transform: translateY(-50%);
        width: pxTorem(790px);
        height: 100%;
        z-index: 100;

        .sns-check-box {
            width: pxTorem(680px);
            box-sizing: border-box;
            padding: pxTorem(44px) pxTorem(74px);
            background: #3e3e3ebb;
            border-radius: 15px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -48%);

            .sns-check-btn--close {
                color: #ffd500;
                position: absolute;
                bottom: 102%;
                right: 0;
                font-size: pxTorem(50px);
                cursor: pointer;
            }

            .sns-check-title {
                color: #fff;
                font-size: pxTorem(24px);
                font-family: 'Noto Sans KR', sans-serif;
            }
            .phone-box {
                width: 100%;
                height: pxTorem(40px);
                background-color: rgba(77, 76, 74, .8);
                position: relative;
                display: flex;
                margin-bottom: pxTorem(25px);
                margin-top: pxTorem(20px);

                
                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, #fff 70%, #fff452);
                    position: absolute;
                    top: 100%;
                    left: 0;
                }

                .phone-pre-num {
                    width: pxTorem(100px);
                    height: 100%;
                    font-family: 'Noto Sans KR', sans-serif;
                    color: #fff;
                    font-size: pxTorem(20px);
                    line-height: pxTorem(40px);
                    text-align: center;
                }
                .phone-content {
                    flex: 1;
                    font-size: 0;

                    .phone-content-input {
                        outline: none;
                        border: 0px;
                        width: 100%;
                        height: 100%;
                        font-size: pxTorem(20px);
                        box-sizing: border-box;
                        background: transparent;
                        color: #fff;
                        font-family: 'Noto Sans KR', sans-serif;
                    }
                }
            }
            .sns-check-btn {
                width: 100%;
                height: pxTorem(42px);
                border: 1px solid #ffd200;
                background: #593418;
                color: #fff;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: pxTorem(30px);

                span {
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: pxTorem(20px);
                    letter-spacing: 3px;
                }
            }
            .sns-check-p {
                width: 100%;
                height: 1px;
                background: linear-gradient(to right, rgba(228, 196, 7, .1), #e4c407 50%, rgba(228, 196, 7, .1));
                margin-bottom: pxTorem(25px);
            }
            .sns-check-tip {
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(25px);
                color: #fff;
                letter-spacing: 2px;
                margin-bottom: pxTorem(15px);
            }
            .toprereg-btn {
                display: block;
                width: 100%;
                cursor: pointer;
            }
        }
    }

    .check-cover-enter-active, .check-cover-leave-active {
        transition: all .3s ease-in-out;
    }
    .check-cover-enter, .check-cover-leave-to {
        opacity: 0;
    }
}
</style>
